import React from 'react';
import { Link } from 'gatsby';

const NotFoundPage = () => (
    <div>
        <br />
        <br />
        <h1>This article is no longer available.</h1>
        <p>
            If you are having difficulties finding answers to your questions, please contact{' '}
            <a href="mailto:support@signiant.com">Signiant Support</a>.
        </p>
        <p>
            <Link to="/">Return Home</Link>
        </p>
    </div>
);

export default NotFoundPage;
